import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { isStaff } from '@utils/getRole';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const accountInfoUpdateService = (data: any) => {
  const URL = isStaff
    ? ENDPOINTS.STAFF.ACCOUNT_INFO.UPDATE
    : ENDPOINTS.ADMIN.ACCOUNT_INFO.UPDATE;
  return axiosInstance
    .put(URL, data)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
